export default __webpack_public_path__ + "static/media/clock.f7332414.svg";